import { getUserStore } from '../store/store';
import { mutatorAction } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

export const updatePrioritizeStatusBarLoadingMessageIndexMutator: (
    mailboxInfo: MailboxInfo,
    index: number
) => void = mutatorAction(
    'incrementPrioritizeStatusBarLoadingMessageIndex',
    (mailboxInfo: MailboxInfo, index: number): void => {
        const store = getUserStore(mailboxInfo);
        store.loadingMessageIndex = index;
    }
);
